import React from 'react';

const SearchBar = ({ searchQuery, setSearchQuery }) => (
  <div className="search-bar">
    <div className="search-container">
      {/* Magnifying glass icon */}
      <div className="search-icon-wrap">
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="11" cy="11" r="7" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
      </div>

      <input
        id="song-search-input"
        type="text"
        placeholder="Search songs, artist, or number (e.g., 001)..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="search-input"
        autoComplete="off"
        spellCheck="false"
      />

      {searchQuery && (
        <button
          onClick={() => setSearchQuery('')}
          className="clear-button"
          aria-label="Clear search"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      )}
    </div>
  </div>
);

export default SearchBar;
